

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};




//////////////////
// WEBPACK FOOTER
// ../node_modules/math-intrinsics/isNaN.js
// module id = ../node_modules/math-intrinsics/isNaN.js
// module chunks = 1